import { PublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "store";
import config from "../authConfig";
import { theme } from "../theme";
import { AuthenticatedContent } from "./AuthenticatedContent";
import { LoginView } from "./LoginView";

/**
 * Main Application Entry Point
 */
// Create a stable MSAL instance outside the component to prevent recreation
// Use "common" authority to handle multi-tenant scenarios properly
const authConfig = new config.AuthConfig("common");
const msalInstance = new PublicClientApplication(authConfig.getMSALConfig());

const App = () => {
	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<MsalProvider instance={msalInstance}>
					<Provider store={store}>
						<UnauthenticatedTemplate>
							<LoginView />
						</UnauthenticatedTemplate>
						<AuthenticatedTemplate>
							<AuthenticatedContent />
						</AuthenticatedTemplate>
					</Provider>
				</MsalProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	);
};

export default App;
